/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_RSUAward_PSUAwardVestingTrancheDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_PSUAwardVestingTrancheDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PsuAwardImportService {

    /**
     * @param batchSize 
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPsuAwardImportUpsertCustomVestingTranches(
batchSize?: number,
requestBody?: Array<Wealthlane_AwardService_Dtos_RSUAward_PSUAwardVestingTrancheDto>,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/psu-award-import/upsert-custom-vesting-tranches',
            query: {
                'batchSize': batchSize,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
